import { createSlice } from "@reduxjs/toolkit";

import { executeSignOut } from "../api/AuthApi";
import { cognitoGroup, storeKeyName } from "../common/AppConstant";
import { handleError } from "../common/ErrorUtil";

/**
 * Slice.
 *
 * @type {object}
 */
export const slice = createSlice({
  // Slice名
  name: storeKeyName.auth,

  // 初期State
  initialState: {
    // 読み込み中フラグ（true: 表示、false: 非表示）
    isLoading: false,
    // エラー内容
    error: null,
    // 所属グループ一覧
    groups: [],
    // ダウンロード可能フラグ（true: 可能、false: 不可能）
    isDownloadable: false,
    // アップロード可能フラグ（true: 可能、false: 不可能）
    isUploadable: false,
    // リモート保守可能フラグ（true: 可能、false: 不可能）
    isRemoteMaintenance: false,
    // ファイル一覧メニュー表示フラグ（true: 表示、false: 非表示）
    isDisplayFilesMenu: true,
    // 工番管理メニュー表示フラグ（true: 表示、false: 非表示）
    isDisplayPressManagementMenu: true,
    // リモート保守ダイアログ表示フラグ（true: 表示、false: 非表示）
    isDisplayRemoteMaintenanceDialog: true,
    // ログインユーザー名
    loginUserName: "",
  },

  // Reducer
  reducers: {
    // 通信開始
    fetchStart(state) {
      state.isLoading = true;
    },
    // 通信失敗
    fetchFailure(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    // 通信成功
    fetchSuccess(state) {
      state.error = null;
      state.isLoading = false;
    },
    // クリア
    fetchClear(state) {
      state.error = null;
      state.groups = [];
      state.isDownloadable = false;
      state.isUploadable = false;
      state.isRemoteMaintenance = false;
      state.isLoading = false;
      state.isDisplayFilesMenu = true;
      state.isDisplayPressManagementMenu = true;
      state.isDisplayRemoteMaintenanceDialog = true;
      state.loginUserName = "";
    },
    // 所属グループ一覧の更新
    fetchUpdateUserInfo(state, action) {
      state.groups = action.payload.groups;
      state.loginUserName = action.payload.userName;
      if (action.payload.groups.includes(cognitoGroup.file)) {
        state.isDownloadable = true;
        state.isUploadable = true;
      }
      if (action.payload.groups.includes(cognitoGroup.fileRead)) {
        state.isDownloadable = true;
      }
      if (action.payload.groups.includes(cognitoGroup.fileWrite)) {
        state.isUploadable = true;
      }
      if (action.payload.groups.includes(cognitoGroup.admin)) {
        state.isRemoteMaintenance = true;
      }
      if (action.payload.groups.includes(cognitoGroup.serviceMan)) {
        state.isDisplayFilesMenu = false;
        state.isDisplayPressManagementMenu = false;
        state.isDisplayRemoteMaintenanceDialog = false;
        state.isRemoteMaintenance = true;
      }
    },
  },
});

/**
 * Actions.
 *
 * @type {object}
 */
export const {
  fetchStart,
  fetchFailure,
  fetchSuccess,
  fetchClear,
  fetchUpdateUserInfo,
} = slice.actions;

/**
 * Selectors.
 *
 * @type {function}
 */
export const selector = (stateAll) =>
  // すべてのStoreのStateが含まれているため、特定のStoreのStateのみ返す
  stateAll[storeKeyName.auth];

/**
 * fetchSignOut.
 *
 */
export const fetchSignOut = () => async (dispatch) => {
  // 通信開始
  dispatch(fetchStart());

  // APIの実行
  const response = await executeSignOut().catch(handleError);
  if (response && response.error) {
    // ローカルストレージの認証情報をクリアする
    localStorage.clear();
    return;
  }

  dispatch(fetchSuccess());
};
